<template>
    <div class="[ c-form-item c-form-radio ] u-pos-relative">
        <input
                class="[ c-form-element c-form-radio-element ]"
                :value="val"
                :class="customClass" type="radio"
                :name="name"
                :id="id"
                :checked="selected"
                @change="updateValue($event.target.value)"
        >
        <v-label :custom-class="`${customLabelClass}`" :id="id">
            <slot></slot>
        </v-label>
    </div>
</template>

<script>
    import VLabel from './Label.vue'

    export default {
        props: {
            name: String,
            customClass: String,
            customLabelClass: String,
            val: [String, Number],
            selected: Boolean,
            fluid: Boolean,
            id: String,
        },

        components: {
            VLabel
        },

        methods: {
            updateValue (value) {
                this.$emit('input', value);
            }
        },

        mounted () {
            if (typeof this.name === "undefined") {
                console.warn(`You are missing a name attribute`);
            }
        },
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/form/Radio.vue